import react, { useEffect, useState } from 'react';
import PopUpLoader from './PopUpLoader';
import axios from 'axios';


const EditLeadPopup = (props) => {
    const [userDetails, setUserDetails] = useState([]);
    const [loadingToggle, setLoadingToggle] = useState(0);
    const [alertToggle, setAlertToggle] = useState(0);
    const [alertMessage, setAlertMessage] = useState("Client Detials successfully added");
    const [alertColor, setAlertColor] = useState("crm-color-green");


    const [clientName, setClientName] = useState("");
    const [email, setEmail] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [businessCategory, setBusinessCategory] = useState("");
    const [website, setWebsite] = useState("");
    const [gmb, setGmb] = useState("");
    const [location, setLocation] = useState("");
    const [work, setWork] = useState("");

    const [message, setMessage] = useState("");
    const [availability, setAvailability] = useState(1);

    const url = window.url;
    const qry = new FormData();

    const fullDate = new Date();

    useEffect(() => {
        if (localStorage.getItem("user")) {
            const userData = JSON.parse(localStorage.getItem("user"));
            setUserDetails(userData);
            // console.log(userData);

            qry.append("emp_id", userData.user_id);

            setClientName(props.data.name);
            setEmail(props.data.email);
            setBusinessName(props.data.business_name);
            setBusinessCategory(props.data.business_category);
            setWebsite(props.data.website);
            setGmb(props.data.gmb);
            setLocation(props.data.location);
            setWork(props.data.work);
            setMessage(props.data.message);
        }
    }, []);


    const addLeadDetailsApi = (e) => {
        e.preventDefault();

        setLoadingToggle(1);
        // alert("Successful");

        // console.log(name+phone+email+adName+platform+site+message+leadGenDate);
        // alert(availability);
        const addLeadDetails = new FormData();
        addLeadDetails.append("emp_id", userDetails.user_id);
        addLeadDetails.append("client_name", clientName);
        addLeadDetails.append("email", email);
        addLeadDetails.append("lead_id", props.leadId);
        addLeadDetails.append("location", location);
        addLeadDetails.append("business_name", businessName);
        addLeadDetails.append("business_category", businessCategory);
        addLeadDetails.append("website", website);
        addLeadDetails.append("gmb", gmb);
        addLeadDetails.append("work", work);
        addLeadDetails.append("message", message);

        axios.post(url + "edit-lead-details.php", addLeadDetails).then(response => {
            console.log(response.data);

            if (response.data.status == 1) {
                setLoadingToggle(0);
                setAlertMessage(response.data.msg);
                setAlertToggle(1);
                props.reload();

                setTimeout(() => {
                    props.close();
                }, 1000);
            }
        }).catch(error => {
            console.log(error);
        })

    }


    return (
        <>
            <div className="dark-background">
                <div className={loadingToggle == 1 || alertToggle == 1 ? 'add-new-lead-popup crm-overflow-h' : 'add-new-lead-popup'}>
                    {loadingToggle == 1 ?
                        <PopUpLoader />
                        : <></>
                    }

                    {alertToggle == 1 ?
                        <div className='crm-alert'>
                            <p className={alertColor}> {alertMessage} </p>
                        </div>
                        : <></>
                    }
                    <div className='add-new-head'>
                        <h2> Edit Details <i className='fa fa-address-card'></i> </h2>
                        <i className='fa fa-times cross' onClick={props.close}></i>
                    </div>

                    <div className='form'>
                        <form onSubmit={addLeadDetailsApi}>

                            <label> Client Name </label>
                            <br />
                            <input type='text' className='form-input' value={clientName} onChange={(e) => setClientName(e.target.value)} placeholder='client name' required />

                            <label> Email </label>
                            <br />
                            <input type='text' className='form-input' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='email' required />

                            <label> Business Name </label>
                            <br />
                            <input type='text' className='form-input' value={businessName} onChange={(e) => setBusinessName(e.target.value)} placeholder='business name' required />

                            <label> Business Category </label>
                            <br />
                            <input type='text' className='form-input' value={businessCategory} onChange={(e) => setBusinessCategory(e.target.value)} placeholder='business category' required />

                            <label> Website </label>
                            <br />
                            <input type='text' className='form-input' value={website} onChange={(e) => setWebsite(e.target.value)} placeholder='website link' required />

                            <label> GMB (Google My Business Profile) </label>
                            <br />
                            <input type='text' className='form-input' value={gmb} onChange={(e) => setGmb(e.target.value)} placeholder='gmb link' required />

                            <label> Location </label>
                            <br />
                            <input type='text' className='form-input' value={location} onChange={(e) => setLocation(e.target.value)} placeholder='location link' required />

                            <label> Work </label>
                            <br />
                            <input type='text' className='form-input' value={work} onChange={(e) => setWork(e.target.value)} placeholder='work' required />

                            <label> Message </label>
                            <br />
                            <textarea name="message" value={message} onChange={(e) => setMessage(e.target.value)} placeholder='message (optional)'></textarea>

                            <br />
                            <button type='submit' className='crm-btn-primary'> Submit </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditLeadPopup;